import React from 'react'
import { Carousel } from 'antd'
import headerBg from '../../../assets/banner_1.png'
import headerBg2 from '../../../assets/banner_2.png'
import codePic from '../../../assets/banner_code.png'
import { toPage } from '../../../utils'
import './index.less'

export default function() {
  return (
    <Carousel
      dotPosition="bottom"
      autoplay
      style={{
        width: '100%',
      }}
    >
      <div>
        <div className="pc-header-wrapper">
          <div
            className="pc-header-wrapper-bg"
            style={{
              backgroundImage: `url(${headerBg})`,
            }}
          >
            <div className="banner-1">
              <>
                <h1>加入国内领先的直播带货与数字营销平台</h1>
                <p>帮你把货卖给5亿+客户，携手共进，遥望未来</p>
                <div>
                  <button onClick={() => toPage('login')}>商家入驻</button>
                  <button
                    onClick={() =>
                      window.open(
                        'https://srm-supplier.ywwl.com/login?platform=supply'
                      )
                    }
                  >
                    商家登录
                  </button>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="pc-header-wrapper">
          <div
            className="pc-header-wrapper-bg"
            style={{
              backgroundImage: `url(${headerBg2})`,
            }}
          >
            <div className="banner-2">
              <div className="content">
                <h1>兴遥云仓仓配一体化服务</h1>
                <p>入仓权益【免保证金】【优先上播】【仓租可免】</p>
                <div
                  className="btn"
                  onClick={() =>
                    toPage('businessDetail?key=yuncang&pageType=pcHome')
                  }
                >
                  查看详情
                </div>
              </div>
              <div
                className="code-pic-content"
                style={{
                  backgroundImage: `url(${codePic})`,
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </Carousel>
  )
}
